import NIF from 'ageas-react-component-nif'

import { t } from '../../i18n'

type Props = {
  id: string
  name: string
  readonly?: boolean
  makeRequest?: boolean
  fiscalNumber?: string
  onChange?: (value: string) => void
  callback?: () => void
  vatNumber?: string
}

export const NIFValidateFiscalNumber = ({
  id,
  name,
  readonly,
  onChange,
  fiscalNumber,
  callback,
  makeRequest = false,
  vatNumber,
  ...rest
}: Props) => {
  const handleChange = (value: string) => {
    onChange && onChange(value)
    callback && callback()
  }

  return (
    <NIF
      id={id}
      name={name}
      required
      readOnly={readonly}
      validateClick
      label={t('pages.step3.identification.vatNumber')}
      value={fiscalNumber || vatNumber}
      onValueChanged={(id: any, value: any, isValid: boolean) => {
        if (value.length > 0) {
          handleChange(value)
        }
      }}
      colorTheme="blue"
      version="2"
      enableOnBlur={true}
      {...rest}
    />
  )
}
